<template>
  <router-view />
</template>

<script>
import { READ, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      sidebar: [
        {
          hidden: this.$user.cannot([READ, UPDATE], this.$sdk.account),
          icon: ['fal', 'edit'],
          route: { name: 'manage-accounts-account-configurations-edit', params: { accountId: this.$route.params.accountId } },
          name: 'Account'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], this.$sdk.account),
          icon: ['fal', 'money-bill-alt'],
          route: { name: 'manage-accounts-account-configurations-billing', params: { accountId: this.$route.params.accountId } },
          name: 'Billing'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], this.$sdk.account),
          icon: ['fal', 'truck-container'],
          route: { name: 'manage-accounts-account-configurations-shipper', params: { accountId: this.$route.params.accountId } },
          name: 'Shipper'
        },
        // {
        //   icon: ['fal', 'mail-bulk'],
        //   route: { name: 'manage-accounts-account-configurations-notificationtemplates', params: { accountId: this.$route.params.accountId } },
        //   name: 'Notification Templates'
        // },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_attachment'),
          icon: ['fal', 'box-open'],
          route: { name: 'manage-accounts-account-configurations-trackingservices', params: { accountId: this.$route.params.accountId } },
          name: 'Track My Parcel'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_carriersetting'),
          icon: ['fal', 'person-carry'],
          route: { name: 'manage-accounts-account-configurations-carriers', params: { accountId: this.$route.params.accountId } },
          name: 'Carriers'
        },
        {
          hidden: false,
          icon: ['fal', 'code-branch'],
          route: { name: 'manage-accounts-account-configurations-rules', params: { accountId: this.$route.params.accountId } },
          name: 'Consignment Rules'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_role'),
          icon: ['fal', 'key'],
          route: { name: 'manage-accounts-account-configurations-roles', params: { accountId: this.$route.params.accountId } },
          name: 'Roles'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'poll-people'],
          route: { name: 'manage-accounts-account-configurations-teams-index', params: { accountId: this.$route.params.accountId } },
          name: 'Teams'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_team'),
          icon: ['fal', 'link'],
          route: { name: 'manage-accounts-account-configurations-webhook', params: { accountId: this.$route.params.accountId } },
          name: 'Webhooks'
        }
      ],
      breadcrumb: {
        name: 'Configurations',
        route: { name: 'manage-accounts-account-configurations', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
